import styles from './results-count.module.scss';
import { MAX_RESULTS_COUNT } from 'helpers/collection-search';
const ResultsCount = ({ totalResults, offset, perPage, query }: IProps) => {
	const ofTotalMessage =
		totalResults >= MAX_RESULTS_COUNT
			? `${MAX_RESULTS_COUNT.toLocaleString()}+ results`
			: `${totalResults.toLocaleString()} results`;
	const startIndex = offset + 1;
	const endIndex =
		offset + perPage < totalResults
			? offset + perPage
			: startIndex + (startIndex + perPage - totalResults);

	const showingNumberOfResultsMessage =
		totalResults === 1
			? 'One result'
			: totalResults < perPage
				? `${totalResults} results`
				: `${startIndex}-${endIndex} of ${ofTotalMessage}`;
	return (
		<div
			className={styles.totalResults}
			data-testid="total-results-message-wrapper"
			data-total-search-results={totalResults}
		>
			<span>{showingNumberOfResultsMessage}</span>
			{query && (
				<span>
					{' '}
					for <span className={styles.resultsMessageQuery}>{query}</span>
				</span>
			)}
		</div>
	);
};

export interface IProps {
	offset?: number;
	perPage: number;
	totalResults: number;
	query: string;
}
export default ResultsCount;
